import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface SendMakeupConfirmationParams {
  makeupId: string;
}

export const sendMakeupConfirmationAPI = async (
  params: SendMakeupConfirmationParams,
) => {
  const response = await baseAPI.post<{ sent: boolean }>(
    `/makeup/${params.makeupId}/send-confirmation`,
  );
  return response.data;
};

export const useSendMakeupConfirmationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: sendMakeupConfirmationAPI,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.MAKEUP_BY_CLASS_DATE],
      });
    },
  });
};
